module.exports = __webpack_public_path__ + "static/media/colombia-top.5e35fc32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tours/colombia-top.jpg
// module id = 298
// module chunks = 0